module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_RO_formatted.35f2d652.pdf";